"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var demo_current_language_provider_service_1 = require("./demo-current-language-provider.service");
var of_1 = require("rxjs/observable/of");
/**
 * Dummy implementation of provider's interface for basic usage.
 * Inherits partial implementation from {@link DummyCurrentLanguageProvider}, other methods
 * imposed by {@link SessionDataProvider} have basic implementation for common needs.
 *
 * @class
 * @extends DummyCurrentLanguageProvider
 * @implements SessionDataProvider
 */
var DemoSessionDataProvider = /** @class */ (function (_super) {
    __extends(DemoSessionDataProvider, _super);
    function DemoSessionDataProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    DemoSessionDataProvider.prototype.getCurrentUserData = function () {
        var userData = new idm_authentication_client_js_1.UserData();
        userData.userId = 84;
        return of_1.of(userData);
    };
    /**
     * @inheritDoc
     */
    DemoSessionDataProvider.prototype.isLoggedOn = function () {
        return of_1.of(true);
    };
    /**
     * @inheritDoc
     */
    DemoSessionDataProvider.prototype.logout = function () {
        return;
    };
    /**
     * @inheritDoc
     */
    DemoSessionDataProvider.prototype.setCurrentLanguageId = function (languageId) {
    };
    return DemoSessionDataProvider;
}(demo_current_language_provider_service_1.DemoCurrentLanguageProvider));
exports.DemoSessionDataProvider = DemoSessionDataProvider;
//# sourceMappingURL=demo-session-data-provider.service.js.map